import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import React from 'react';
import { Breadcrumb } from 'semantic-ui-react';
import _capitalize from 'lodash/capitalize';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import Markdown from 'markdown-to-jsx';
import { formatAuthor } from './BlogPost.presenters';
import Image from '../../atoms/Image';
import Link from '../../atoms/Link';
import { BlogPostSchema } from '../../darkmatter/SEO';
import { cleanSlug } from '../../modules/navigation/services/slugs';
import { ImagePropType } from '../../services/proptypes';
import DateUtils from '../../utils/date/DateUtils';
import './BlogPost.less';
export default function BlogPost(_ref) {
  var title = _ref.title,
    publishedAt = _ref.publishedAt,
    author = _ref.author,
    heroImage = _ref.heroImage,
    content = _ref.content,
    markdown = _ref.markdown,
    summary = _ref.summary,
    blogRootSlug = _ref.blogRootSlug;
  function getHeaderText() {
    var authorString = formatAuthor(author);
    var headerParts = !_isEmpty(publishedAt) ? [DateUtils.format(DateUtils.parseISO(publishedAt), 'PPP')] : [];
    if (!_isEmpty(authorString)) {
      headerParts = [authorString].concat(_toConsumableArray(headerParts));
    }
    return headerParts.join(' | ');
  }
  function getContent() {
    return markdown ? /*#__PURE__*/React.createElement(Markdown, null, content) : content;
  }
  function createSchemaProps() {
    return {
      title: title,
      content: content,
      summary: summary,
      datePublished: publishedAt,
      author: formatAuthor(author),
      heroImage: _get(heroImage, 'fluid.src')
    };
  }
  var headerText = getHeaderText();
  var cleanedRootSlug = cleanSlug(blogRootSlug);
  return /*#__PURE__*/React.createElement("div", {
    className: "blog-post"
  }, /*#__PURE__*/React.createElement(BlogPostSchema, createSchemaProps()), /*#__PURE__*/React.createElement(Breadcrumb, {
    className: "blog-post-breadcrumbs"
  }, /*#__PURE__*/React.createElement(Breadcrumb.Section, {
    as: Link,
    title: _capitalize(cleanedRootSlug),
    to: blogRootSlug
  }), /*#__PURE__*/React.createElement(Breadcrumb.Divider, {
    icon: "right chevron"
  }), /*#__PURE__*/React.createElement(Breadcrumb.Section, null, title)), /*#__PURE__*/React.createElement("article", null, /*#__PURE__*/React.createElement("header", null, /*#__PURE__*/React.createElement("h1", {
    className: "title"
  }, title), heroImage && /*#__PURE__*/React.createElement(Image, {
    src: heroImage,
    className: "blog-post-image"
  }), !_isEmpty(headerText) && /*#__PURE__*/React.createElement("header", {
    className: "author-and-date"
  }, headerText)), /*#__PURE__*/React.createElement("section", {
    className: "blog-post-content-section ".concat(markdown ? '' : 'white-space-line-break')
  }, getContent())));
}
BlogPost.defaultProps = {
  publishedAt: '',
  heroImage: null,
  author: null,
  markdown: false,
  summary: '',
  blogRootSlug: '/blog/'
};